global.userUnitList = global.API_USER_URL+'userUnitList/';
global.userAddUnit = global.API_USER_URL+'userAddUnit/';
global.userEditUnit = global.API_USER_URL+'userEditUnit/';
global.userUnitDetails = global.API_USER_URL+'unitDetails/';
global.userUnitDelete = global.API_USER_URL+'userUnitDelete/';
global.userAddUnitConversion = global.API_USER_URL+'userAddUnitConversion/';
global.userUnitConversionList = global.API_USER_URL+'userUnitConversionList/';
global.userUnitLastConversionList = global.API_USER_URL+'userUnitLastConversionList/';
global.userAddDefaultUnitConversion = global.API_USER_URL+'userAddDefaultUnitConversion/';